import * as z from "zod";

export const formSchema = z.object({
    firstName: z.string().nonempty({ message: "First name is required." }),
    lastName: z.string().nonempty({ message: "Last name is required." }),
    email: z.email({ message: "Please enter valid email address." })
});

export type InviteStaffFormValues = z.infer<typeof formSchema>;
